export default __webpack_public_path__ + "static/media/sprite_categories.39bce364.svg";